import { useState, useCallback } from "react";
import { TrialExhaustedDialog } from "@/components/trial-exhausted-dialog";
import { getTrialExhaustedPayload, type TrialExhaustedPayload } from "@/lib/trial-exhausted";
import type { AuthUser } from "@/hooks/useAuth";
import { isTrialExhausted } from "@/lib/trial";

export function useTrialExhaustedDialog() {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState<TrialExhaustedPayload | null>(null);

  const showTrialExhaustedDialog = useCallback((err: unknown) => {
    const p = getTrialExhaustedPayload(err);
    if (!p) return false;
    setPayload(p);
    setOpen(true);
    return true;
  }, []);

  /** Open the same dialog from client state (e.g. header New Entry when trial is exhausted). */
  const openTrialExhaustedFromProfile = useCallback((user: AuthUser | null | undefined) => {
    if (!isTrialExhausted(user)) return;
    const u = user!;
    setPayload({
      limit: u.trialEntriesLimit ?? undefined,
      used: u.trialEntriesUsed ?? undefined,
      plan: u.plan,
    });
    setOpen(true);
  }, []);

  const trialExhaustedDialog = (
    <TrialExhaustedDialog
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        if (!next) setPayload(null);
      }}
      payload={payload}
    />
  );

  return { trialExhaustedDialog, showTrialExhaustedDialog, openTrialExhaustedFromProfile };
}
